import { statusLabel } from "@/lib/format";

const MAP = {
  em_dia:    "bg-emerald-50 text-emerald-700 border-emerald-200",
  proximo:   "bg-amber-50 text-amber-700 border-amber-200",
  vencido:   "bg-rose-50 text-rose-700 border-rose-200",
  inativo:   "bg-zinc-100 text-zinc-600 border-zinc-200",
  bloqueado: "bg-zinc-900 text-zinc-100 border-zinc-700",
  ativo:     "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const StatusBadge = ({ status }) => {
  const cls = MAP[status] || "bg-zinc-100 text-zinc-700 border-zinc-200";
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-medium border ${cls}`} data-testid={`status-badge-${status}`}>
      {statusLabel[status] || status}
    </span>
  );
};
